import { api } from "../api";

/**
 * API de Gestão de Tipos de Documentos (Admin)
 * Endpoints administrativos para gerenciar tipos de documentos
 */

/**
 * Listar todos os tipos de documentos
 * @param {boolean} activeOnly - Se true, retorna apenas tipos ativos
 * @returns {Promise} - Array de DocumentTypeResponseDTO
 */
export const getAllDocumentTypes = async (activeOnly = false) => {
  const response = await api.get("/admin/document-types", {
    params: { activeOnly },
  });
  return response.data;
};

/**
 * Buscar tipo de documento por ID
 * @param {number} id - ID do tipo de documento
 * @returns {Promise} - DocumentTypeResponseDTO
 */
export const getDocumentTypeById = async (id) => {
  const response = await api.get(`/admin/document-types/${id}`);
  return response.data;
};

/**
 * Criar novo tipo de documento
 * @param {object} data - Dados do tipo de documento
 * @param {string} data.name - Nome do tipo
 * @param {string} data.category - Categoria
 * @param {string[]} data.allowedExtensions - Extensões permitidas
 * @param {number} data.maxSizeMB - Tamanho máximo em MB
 * @param {number} data.displayOrder - Ordem de exibição
 * @param {string} data.description - Descrição
 * @param {boolean} data.isActive - Se está ativo
 * @returns {Promise} - DocumentTypeResponseDTO
 */
export const createDocumentType = async (data) => {
  const response = await api.post("/admin/document-types", data);
  return response.data;
};

/**
 * Atualizar tipo de documento
 * @param {number} id - ID do tipo de documento
 * @param {object} data - Dados a atualizar
 * @returns {Promise} - DocumentTypeResponseDTO
 */
export const updateDocumentType = async (id, data) => {
  const response = await api.put(`/admin/document-types/${id}`, data);
  return response.data;
};

/**
 * Ativar/desativar tipo de documento
 * @param {number} id - ID do tipo de documento
 * @param {boolean} isActive - Novo status
 * @returns {Promise} - DocumentTypeResponseDTO
 */
export const toggleDocumentType = async (id, isActive) => {
  const response = await api.put(`/admin/document-types/${id}/toggle`, { isActive });
  return response.data;
};

/**
 * Deletar tipo de documento
 * @param {number} id - ID do tipo de documento
 * @returns {Promise}
 */
export const deleteDocumentType = async (id) => {
  const response = await api.delete(`/admin/document-types/${id}`);
  return response.data;
};

